// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".benefit-box[data-v-7d44a1a6] {\n  width: 600px;\n}", ""]);
// Exports
module.exports = exports;
